export default __webpack_public_path__ + "static/media/mobile_85.4dc1bcea.jpg";